<template>
  <div v-if="bannerInfo && bannerImage">
    <div
      :class="['panel', 'voucher-panel', { active: viewMoreState }]"
      :style="getBgColor"
    >
      <button type="button" class="panel-trigger" @click="onToggleViewMore">
        CRM 배너 여닫기
      </button>

      <div class="panel-content">
        <img
          v-if="targetBanner"
          :src="bannerImage"
          :alt="bannerImgAlt"
          :class="['banner-image', { loaded: isImageLoaded }]"
          @load="onImageLoaded"
        />
        <a
          v-if="bannerLinkUrl"
          href="#"
          :target="attrTarget"
          rel="noopener noreferrer"
          @click.prevent="goDetail(bannerLinkUrl)"
        >
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, defineProps, watch } from 'vue'
  import { getFromUrl, getUiserviceBannerSingle } from '@/common/utils/request'
  import { bannerLink } from '@/common/utils/common'
  import cookie from '@/common/utils/cookie'
  import { resizeThumbnail } from '@/common/utils/image'

  const props = defineProps({
    bannerId: {
      type: String,
      default: '',
    },
    bannerJsonUrl: {
      type: String,
      default: '',
    },
    bannerIndex: {
      type: Number,
      default: -1,
    },
  })

  const bannerInfo = ref(null)
  const viewMoreState = ref(false)
  const isImageLoaded = ref(false)

  const targetBanner = computed(
    () => bannerInfo.value?.band?.celllist?.[props.bannerIndex] ?? {},
  )
  const getBgColor = computed(
    () => `background-color:${targetBanner.value?.bgcolor ?? ''}`,
  )
  const bannerImgAlt = computed(
    () => targetBanner.value?.title_list?.[0]?.text ?? '',
  )
  const bannerImage = computed(() => {
    if (!targetBanner.value?.thumbnail) {
      return undefined
    }
    return resizeThumbnail(targetBanner.value.thumbnail, {
      width: 0,
      height: 0,
      option: 20,
      quality: 80,
    })
  })
  const bannerLinkUrl = computed(
    () => targetBanner.value?.event_list?.[1]?.url ?? '',
  )
  const attrTarget = computed(() =>
    bannerLinkUrl.value.includes('www.wavve.com') ? '_self' : '_blank',
  )

  const onImageLoaded = () => {
    isImageLoaded.value = true
  }

  const goDetail = (url) => bannerLink(url)

  const onToggleViewMore = () => {
    viewMoreState.value = !viewMoreState.value
  }

  const setBannerData = () => {
    const isLogin = cookie.getCredential() !== 'none'
    const timeStamp = new Date().getTime()

    if (!isLogin && props.bannerId === 'oksusu') {
      return undefined
    }

    if (!props.bannerJsonUrl) {
      return getUiserviceBannerSingle({ bannerid: props.bannerId })
    }

    return getFromUrl({
      url: `${props.bannerJsonUrl}?timeStamp=${timeStamp}`,
    })
  }

  const getBannerInfo = async () => {
    isImageLoaded.value = false
    try {
      const { data } = await setBannerData()
      bannerInfo.value = data ?? {}
      isImageLoaded.value = true
    } catch (error) {
      console.error(`Error get Banner Data : ${error.message}`)
    }
  }

  const init = () => {
    getBannerInfo()
  }

  init()

  watch(
    () => props.bannerIndex,
    () => {
      getBannerInfo()
    },
  )
</script>
<style lang="scss" scoped>
  .banner-image {
    transform: translateZ(0);
    opacity: 0;
    will-change: transform;
    &.loaded {
      transition: opacity 0.2s ease-in-out 0.1s;
      opacity: 1;
    }
  }
</style>
